import React,{useEffect,useState} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import Home from 'pages/Home';
import About from 'pages/About';
import CreateConfirm from 'pages/CreateConfirm';
import StepperFormIndex from 'pages/StepperForm/index';
import BasicConfiguration from 'pages/StepperForm/BasicConfiguration';
import getToken from 'pages/getToken';

import './App.css';
import { createColumnQuery, createStatusColumnQuery, getSubScription, mondayContextProcess, readColumnsQuery } from 'services/MondayService';
import SubscriptionPage from 'components/Subscription';

function App() {
  const [loading, setLoading] = useState(false);
  const [noSubscription, setNoSubscription] = useState(false);


  useEffect(() => {
    const subscriptionCheckAndColumnCreation=async()=>{
      try {
        setLoading(true);
        const getMondayContext=await mondayContextProcess();
        const boardId=getMondayContext.boardId;
        const getSubScriptionDetails=await getSubScription();
        console.log('getSubScriptionDetails ',getSubScriptionDetails);
        const readColumnRespones=await readColumnsQuery(parseInt(boardId));
        const columnValues=readColumnRespones.data.boards[0].columns;
        const checkIntegrationIdIsThere=columnValues.some(item=>item.id=='intg_id_servicenow');
        const checkIntegrationNumberIsThere=columnValues.some(item=>item.id=='number_servicenow');
        const checkErrorMessageColumnIsThere=columnValues.some(item=>item.id=='sync_error_message');
        const checkStatusColumnIsThere=columnValues.some(item=>item.id=='sync_status_column');
        console.log('checkIntegrationIdIsThere ',checkIntegrationIdIsThere);
        console.log('checkIntegrationNumberIsThere ',checkIntegrationNumberIsThere);
        console.log('checkErrorMessageColumnIsThere ',checkErrorMessageColumnIsThere);
        console.log('checkStatusColumnIsThere ',checkStatusColumnIsThere);
        console.log('columnValues ',columnValues);
        if (!getSubScriptionDetails.data.app_subscription.length) {
          setNoSubscription(true);
        } else if(getSubScriptionDetails.data.app_subscription[0].days_left > 0) {
          if(!checkIntegrationIdIsThere){
            await createColumnQuery(boardId,'**Integration Id','text','intg_id_servicenow');
          }
          if(!checkIntegrationNumberIsThere){
            await createColumnQuery(boardId,'Number','text','number_servicenow');
          }
          if(!checkErrorMessageColumnIsThere){
            await createColumnQuery(boardId,'Sync Error Message','long_text','sync_error_message');
          }
          if(!checkStatusColumnIsThere){
            const statusColumnLabels={
              labels: {
                1: 'Sync Success',
                2: 'Sync Fail',
              }
            };
            await createStatusColumnQuery(boardId,'Sync Status','status','sync_status_column',statusColumnLabels);
          }
          // url= process.env.APP_FRONTEND_URL+'/exist_account'+'?'+'backToUrl='+backToUrl+'&userId='+userId+'&accountId='+accountId+'&boardId='+boardId+'&recipeId='+recipeId+'&mondayToken='+objTemp.shortLivedToken;
        }else{
          setNoSubscription(true);
        }

      }catch(error){
        console.error('Error during subscription check and column creation:', error);
      }finally{
        setLoading(false);
      }

    };
    subscriptionCheckAndColumnCreation();
  }, []);

  if(loading){
   return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  if(noSubscription){
    return <SubscriptionPage/>;
  }


  return (
    <>
      <Router>
        <Switch>

          {/* Default route */}
          <Route exact path="/">
            <Redirect to="/exist_account" />
          </Route>

          <Route exact path="/exist_account" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/createConfirm" component={CreateConfirm} />
          <Route path="/StepperFormIndex" component={StepperFormIndex} />
          <Route path="/BasicConfiguration" component={BasicConfiguration} />
          <Route path="/getOauthToken" component={getToken} exact />

        </Switch>
      </Router>
    </>
  );
}

export default App;